import React, {VoidFunctionComponent} from 'react';

import Tags from '../../../tags/tags';

import useTags from '../../../../../hooks/useTags';

const TagsFilters: VoidFunctionComponent = () => {
  const {tagsFilterEntries} = useTags();
  const tagsFilterList = tagsFilterEntries.map(tag => tag.label).sort();

  return <Tags tags={tagsFilterList} isFilter={true} />;
};
export default TagsFilters;
